/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyCreateDTO } from '../models/SurveyCreateDTO'
import type { TaskDTO } from '../models/TaskDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class SurveyService {
    /**
     * Submit Survey Result
     * @returns TaskDTO Successful Response
     * @throws ApiError
     */
    public static submitSurveyResultSurveyPost({ requestBody }: { requestBody: SurveyCreateDTO }): CancelablePromise<TaskDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/joint-insights/survey',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
}
